// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TabContent_tabContent__cfwpQ {
  background: var(--color-surface);
  padding: var(--gutter);
  min-height: calc(100vh - var(--nav-height) - 40px);
}`, "",{"version":3,"sources":["webpack://./src/components/TabContent/TabContent.module.scss"],"names":[],"mappings":"AAAA;EACE,gCAAA;EACA,sBAAA;EACA,kDAAA;AACF","sourcesContent":[".tabContent {\n  background: var(--color-surface);\n  padding: var(--gutter);\n  min-height: calc(100vh - var(--nav-height) - 40px);\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabContent": `TabContent_tabContent__cfwpQ`
};
export default ___CSS_LOADER_EXPORT___;
